import Flex from 'components/common/Flex'
import LoginForm from "./components/LoginForm";

const Login = () => {
  return (
    <div className='zoom-80'>
      <Flex alignItems="center" justifyContent="between">
        <h3>Login</h3>
      </Flex>
      <LoginForm />
    </div>
  )
}

export default Login